var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1447",
    "data-name": "Groupe 1447",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1231",
    "data-name": "Groupe 1231",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    fill: "#fff9e9",
    stroke: "#fdc22b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1437",
    "data-name": "Groupe 1437",
    transform: "translate(19 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_712",
    "data-name": "Trac\\xE9 712",
    d: "M1848.858,654.117q.71,0,1.438.055c.123.009.247.02.373.032a1.418,1.418,0,0,1,1.285,1.292v.012a7.624,7.624,0,0,1-.1,2.038l0,.027a1.42,1.42,0,0,1-1.277,1.162q-.193.017-.381.03-.68.047-1.34.047t-1.341-.047q-.188-.013-.381-.03a1.419,1.419,0,0,1-1.276-1.162l0-.026a7.868,7.868,0,0,1-.116-1.01,7.966,7.966,0,0,1,.02-1.028V655.5a1.419,1.419,0,0,1,1.285-1.293q.19-.018.374-.032Q1848.146,654.118,1848.858,654.117Zm-3.976-18.476a1.421,1.421,0,0,1,1.3-1.508q.371-.033.733-.05,1.031-.045,1.947-.046t1.923.046q.379.017.776.054a1.416,1.416,0,0,1,1.276,1.506l-.965,14.554a1.415,1.415,0,0,1-1.254,1.317c-.154.017-.3.031-.441.044q-.695.059-1.316.058a16.492,16.492,0,0,1-1.75-.111,1.42,1.42,0,0,1-1.262-1.318Z",
    transform: "translate(-1844.879 -634.037)",
    fill: "#fdc22b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBox);
export default __webpack_public_path__ + "static/media/img_box.288448b6e836103986a6d9ed40af74b7.svg";
export { ForwardRef as ReactComponent };